// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  region: "",
  ClientId: '',
  credentials: {
    accessKeyId: "",
    secretAccessKey: ""
  },
  UserPoolId: '',
  cmsUri: '',
  cmsToken: '',
  dataProxy: 'https://sense-dev-api.koreda.app/api/data-proxy/query?query=',
  contactApi: 'https://sense-dev-api.koreda.app/api/contact-us',
  dailyReportUrl: 'https://daily-report-dev.koreda.app/{2}?date={0}&t={1}',
  dailyReportHistUrl: 'https://sense-dev-api.koreda.app/api/daily-report/hist/{2}?date={0}&t={1}&dataupdate={3}',
  dailyCategoryPackageReportUrl: 'https://sense-dev-api.koreda.app/api/category-package-report/Query?date={date}',
  dailyCategoryPackageCheckFileReportOnS3Url: 'https://sense-dev-api.koreda.app/api/snowflake-proxy/CheckCategoryPackageReportExistOnS3?date={date}',
  dailyCategoryPackageReportHistUrl: 'https://sense-dev-api.koreda.app/api/daily-report/histCTGPKG/{2}?date={0}&t={1}&dataupdate={3}',
  snowflakeProxy:'https://sense-dev-api.koreda.app/api/snowflake-proxy/query',
  hygraphGetCustomer:'https://sense-dev-api.koreda.app/api/hygraph/GetCustomerQuery',
  hygraphGetJobUpdate:'https://sense-dev-api.koreda.app/api/hygraph/GetJobUpdate',
  hygraphGet445ReportJobUpdate:'https://sense-dev-api.koreda.app/api/hygraph/Get445ReportJobUpdate',
  hygraphGetSEJobUpdate:'https://sense-dev-api.koreda.app/api/hygraph/GetSEJobUpdate',
  hygraphGetTraxJobUpdate:'https://sense-dev-api.koreda.app/api/hygraph/GetPhotoRecognitionJobUpdate',
  hygraphGetCategoryPackageJobUpdate:'https://sense-dev-api.koreda.app/api/hygraph/GetCategoryPackageJobUpdate',
  hygraphGetMenus:'https://sense-dev-api.koreda.app/api/hygraph/GetMenusQuery',
  hygraphGetUsers:'https://sense-dev-api.koreda.app/api/hygraph/GetUsers',
  hygraphGetComment:'https://sense-dev-api.koreda.app/api/hygraph/GetComment',
  hygraphCreateComment:'https://sense-dev-api.koreda.app/api/hygraph/CreateComment',
  hygraphUpdateComment:'https://sense-dev-api.koreda.app/api/hygraph/UpdateComment',
  hygraphDeleteComment:'https://sense-dev-api.koreda.app/api/hygraph/DeleteComment',
  hygraphCommentPermission:'https://sense-dev-api.koreda.app/api/hygraph/GetCommentPermission',
  hygraphGetNotification:'https://sense-dev-api.koreda.app/api/hygraph/GetNotification',
  commentsendemail:'https://sense-dev-api.koreda.app/api/email/index',
  snowflakeProxyV2 : 'https://sense-dev-api.koreda.app/api/v2/snowflake-proxy/query',
  chatbotAPI: 'https://sense-dev-api.koreda.app/api/analyst/message',
  senseVideo:'https://sense-dev-api.koreda.app/api/video/GetVideoByKey',
  notificationApi: 'https://sense-dev-api.koreda.app/api/notification',
  saveReportPdf: 'https://sense-dev-api.koreda.app/api/ping/SavePdfFile',
  chatbotInsightAPI: 'https://sense-dev-api.koreda.app/api/analyst/insight',
  chatbotFeedbackApi: 'https://sense-dev-api.koreda.app/api/analyst/feedback',
  clientId: "88695939-45ad-4345-a11d-72f0237d8d67",
  authority: "https://login.microsoftonline.com/52f958ed-e366-4ad5-bdcf-9115f6e29b35",
  authenserver: "api://88695939-45ad-4345-a11d-72f0237d8d67/authenserver",
  redirectUri: 'https://sense-dev.koreda.app/processing',
  customer: 'customers',
  checkToken: 'https://sense-dev-api.koreda.app/CheckToken',
  clearCacheJobStatus: 'clearCacheJobDevs',
  clearCache445JobStatus: 'report445Jobs',
  clearCategoryPackageCacheJobStatus: 'clearCategoryPackageCacheJobDevs',
  comment: 'comments',
  clearCacheSEJobStatus: 'clearCacheSEJobDevs',
  clearCacheTraxJobStatus: 'clearCachePhotoRecognitionJobDevs',
  menuSection: 'menuSections', 
  cmsEnv: 'DEV',
  apiverifyWP98: 'https://sense-dev-blog.koreda.app/wp-json/azure/v1/verify',
  home: 'https://sense-dev.koreda.app',
  homeWP98: 'https://sense-dev-blog.koreda.app',
  dailyReportSummary:'https://sense-dev-api.koreda.app/api/dailyreport-summary/GetSummaryData',
  dailyReportDownload:'https://sense-dev-api.koreda.app/api/snowflake-proxy/CheckFileExistOnS3',
  dailyReport445Summary:'https://sense-dev-api.koreda.app/api/dailyreport-summary/GetSummary445Data',
  dailyReport445Download:'https://sense-dev-api.koreda.app/api/snowflake-proxy/CheckFile445ExistOnS3'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
